var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#232E78"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 20C31.3902 20 30.8302 19.65 30.5502 19.11L29.8302 17.66C29.3702 16.75 28.1702 16 27.1502 16H24.8602C23.8302 16 22.6302 16.75 22.1702 17.66L21.4502 19.11C21.1702 19.65 20.6102 20 20.0002 20C17.8302 20 16.1102 21.83 16.2502 23.99L16.7702 32.25C16.8902 34.31 18.0002 36 20.7602 36H31.2402C34.0002 36 35.1002 34.31 35.2302 32.25L35.7502 23.99C35.8902 21.83 34.1702 20 32.0002 20ZM24.5002 21.25H27.5002C27.9102 21.25 28.2502 21.59 28.2502 22C28.2502 22.41 27.9102 22.75 27.5002 22.75H24.5002C24.0902 22.75 23.7502 22.41 23.7502 22C23.7502 21.59 24.0902 21.25 24.5002 21.25ZM26.0002 32.12C24.1402 32.12 22.6202 30.61 22.6202 28.74C22.6202 26.87 24.1302 25.36 26.0002 25.36C27.8702 25.36 29.3802 26.87 29.3802 28.74C29.3802 30.61 27.8602 32.12 26.0002 32.12Z",
    fill: "#0D1756"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a426da7338dd92c17e68708182da04e1.svg";
export { ForwardRef as ReactComponent };